
import {
  defineComponent,
  ref,
  computed,
  getCurrentInstance,
  ComponentInternalInstance,
  toRefs,
  onMounted,
} from 'vue-demi';
import tiktokPostWrap from './data-wraper.vue';
import PopupIdentity from 'src/components/tiktok-post/popup-identity.vue';
import adsCreative from '@/store/modules/ads_creative';
import Popup from '@/components/popup/popup.vue';
import identityStore from '@/store/modules/identity';
import { IdentityType, MaterialSource, NativeMaterialItem, NativeMaterialStatus, videoStage } from '@/const/media';
import teaTracker from '@/tea-tracker';
import { TEA_EVENT } from '@/const/state/TeaNames';
import { useIdentityHooks } from '@/hooks/global/useIdentityHooks';

const name = 'TikTokPost';
export default defineComponent({
  name,
  components: {
    Popup,
    PopupIdentity,
    tiktokPostWrap,
  },
  props: {
    tiktokPostShow: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, cxt) {
    const { proxy: _this } = getCurrentInstance() as ComponentInternalInstance;
    const showTikTokAccountSelection = ref(false);
    const { tiktokPostShow } = toRefs(props);
    const identity = computed(() => adsCreative.getters.identityFormData.value);
    const displayName = computed(() => identity.value?.curIdentity?.display_name || '');
    const videoList = computed(() => adsCreative.getters.identityFormData.value.videoList);
    const creative = computed(() => adsCreative.getters.creativeFormData.value);
    const localIdentity = ref(identity.value.curIdentity);
    const localVideoList = ref(videoList.value);
    const avatarUrl = computed(() => identity.value.curIdentity?.avatar_icon?.url || '');
    const { identityList } = useIdentityHooks();
    const tiktokPostDisplay = async (): Promise<void> => {
      _this.$Loading.show();
      showTikTokAccountSelection.value = false;
      tiktokPostShow.value = true;
      try {
        if (identityStore.getters.identityFormData.value.curIdentity) {
          const { identity_type, identity_id } = identityStore.getters.identityFormData.value.curIdentity;
          await identityStore.actions.getNativeMaterialList(identity_type, identity_id);
        }
      } catch (e) {
        // 素材拉取失败展示empty页面，这里不需要额外处理
      } finally {
        _this.$Loading.hide();
      }
    };
    const updateIdentity = async (selectedIdentity): Promise<void> => {
      const nextTiktokAccount = identityList.value.filter(id => id.identity_id === selectedIdentity.identity_id);
      const identityInfo = nextTiktokAccount?.[0];
      identityStore.mutations.setCurIdentity(identityInfo);
      identityStore.mutations.setDisplayName(identityInfo.display_name);
      identityStore.mutations.setAvatarIcon(identityInfo.avatar_icon);
      await tiktokPostDisplay();
      teaTracker.trackEvent(TEA_EVENT.USER_SELECT_A_TIKTOK_ACCOUNT);
    };
    const handleCloseIdentity = (show): void => {
      if (show !== undefined) {
        showTikTokAccountSelection.value = show;
        teaTracker.trackEvent(TEA_EVENT.USER_OPEN_TIKTOK_ACCOUNT_SELECTION);
        return;
      }
      showTikTokAccountSelection.value = !showTikTokAccountSelection.value;
    };
    const videoSelection = videoInfo => {
      const { curIdentity } = identityStore.getters.identityFormData.value;
      const { identity_type } = curIdentity;
      adsCreative.mutations.setUsingTikTokAccountUnderOwner(identity_type === IdentityType.TT_USER);
      adsCreative.mutations.setActiveSource(MaterialSource.TIKTOK_VIDEO);
      adsCreative.mutations.setSelectedVideo(videoInfo);
      adsCreative.mutations.setClearCreativeData();
      adsCreative.mutations.setVideoStage(videoStage.FINISH);
      adsCreative.mutations.setTitle(videoInfo?.text || '');
      identityStore.mutations.setUseTikTokIdentity(true);
      identityStore.mutations.setAvatarIcon(curIdentity.avatar_icon);
      identityStore.mutations.setDisplayName(curIdentity.display_name);
      cxt.emit('updateStatus', false, true);
      teaTracker.trackEvent(TEA_EVENT.USER_CHOOSE_TIKTOK_POST);
    };
    const tiktokOptionsByPop = computed(() =>
      identity.value.identityList.map(item => ({
        value: item.display_name,
        label: item.avatar_icon?.url,
        key: item.identity_id,
      })),
    );
    const getInvalidHint = (item: NativeMaterialItem) => {
      const { available_status } = adsCreative.state.identity.curIdentity?.value;
      if (available_status !== 0) {
        return 'fastcreation_identity_invalid_desc';
      }
      if (item.status !== NativeMaterialStatus.AUTHORIZED) {
        return 'fastcreation_media_ttvideo_unauthorized_hint';
      }
      // hint文案为空则认为素材有效
      return '';
    };
    const handleClosePopup = () => {
      adsCreative.mutations.setCustomIdentity(localIdentity.value);
      adsCreative.mutations.setDisplayName(localIdentity.value.display_name);
      adsCreative.mutations.setImageInfo(localIdentity.value.avatar_icon);
      adsCreative.mutations.setNativeMaterialInfo(localVideoList.value);
      cxt.emit('updateStatus', false);
    };
    onMounted(async () => {
      _this.$Loading.show();
      try {
        const { identity_type, identity_id } = identityStore.state.identity.identityList?.value?.[0];
        await identityStore.actions.getNativeMaterialList(identity_type, identity_id);
      } catch (e) {
        console.log(e);
      } finally {
        _this.$Loading.hide();
      }
    });
    return {
      identity,
      videoList,
      creative,
      avatarUrl,
      displayName,
      updateIdentity,
      videoSelection,
      getInvalidHint,
      tiktokOptionsByPop,
      handleClosePopup,
      handleCloseIdentity,
      showTikTokAccountSelection,
    };
  },
});
